<template>
    <div class="fs5-sidebar">
        <div class="sidebar-all">
            <div class="sidebar-responsive">
                <div class="sidebar-responsive-content">
                    <div>
                        <p class="sidebar-responsive-p" v-html="view[0]['titulo']"></p>
                    </div>
                    <div class="sidebar-btn-expand">
                        <button class="sidebar-expand" @click="expandResponsive()">
                            <img :class="['sidebar-vector',!openAll ? '' : 'sidebar-rotate180']" src="/internacional/public/office5/img/access-menu/default/vector.svg">
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="openAll">
                <ul class="sidebar-ul-first">
                    <li class="sidebar-li-first" v-for="(menu,value) in item[0]['menu']" :key="value">
                        <div v-if="menu.route.name || Object.keys(menu['menu']).length > 0 || menu.modal" :class="['sidebar-icon-text',!menu['class'] ? '' : 'active-menu', menu.is_submenu || menu.is_new == '1' || menu.is_beta_test == '1' ? 'sidebar-justify' : '']">
                            <div>
                                <img class="sidebar-icon" :src="'/internacional/public/office5/img/access-menu/default/'+menu.icon" :alt="menu.titulo">
                            </div>
                            <div class="sidebar-box-title">
                                <label v-if="!menu.route.name" :for="'btnCollapse'+value" class="sidebar-label-first" @click="!menu.modal ? '' : openModal(menu.modal)" v-html="menu.titulo"></label>
                                <a v-if="menu.route.name" :class="['sidebar-a-first', pathName == menu.route.name ? 'sidebar-current' : '']" :href="!menu.route.name ? menu.route.link : menu.route.name" v-html="menu.titulo"></a>
                            </div>
                            <div v-if="!menu.is_submenu && Object.keys(menu['menu']).length == 0 && menu.is_new == '1'">
                                <div class="sidebar-badge" v-html="menu.label_is_new"></div>
                            </div>
                            <div v-if="!menu.is_submenu && Object.keys(menu['menu']).length == 0 && menu.is_beta_test == '1'">
                                <div class="sidebar-badge" v-html="menu.label_is_beta"></div>
                            </div>
                            <div class="sidebar-btn-expand" v-if="menu.is_submenu && Object.keys(menu['menu']).length > 0">
                                <button :id="'btnCollapse'+value" class="sidebar-expand" @click="expand(value)">
                                    <img :class="['sidebar-vector',!menu['status_collapse'] ? '' : 'sidebar-rotate180']" src="/internacional/public/office5/img/access-menu/default/vector.svg" :alt="menu.titulo">
                                </button>
                            </div>
                        </div>
                        <ul class="sidebar-ul-second" v-if="menu['status_collapse']">
                            <li class="sidebar-li-second" v-for="(submenu,y) in menu['menu']" :key="y">
                                <div class="sidebar-submenu sidebar-justify">
                                    <div>
                                        <a :class="['sidebar-a-second', pathName == submenu.route.name ? 'sidebar-current' : '']" :href="!submenu.route.name ? submenu.route.link : submenu.route.name" :target="submenu.route.target" v-html="submenu.titulo"></a>
                                    </div>
                                    <div v-if="submenu.is_new == 1">
                                        <div class="sidebar-badge" v-html="submenu.label_is_new"></div>
                                    </div>
                                    <div v-if="submenu.is_beta_test == 1">
                                        <div class="sidebar-badge" v-html="submenu.label_is_beta"></div>
                                    </div>
                                    <div v-if="submenu.notification">
                                        <div class="sidebar-badge-notification" v-html="view[2]"></div>
                                        <div class="sidebar-notification" v-html="submenu.notification"></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
    export default {
        name: 'fs5-sidebar',
        props: ['view'],
        data() {
            return {
                item: [{'menu':{}}],
                openAll: true,
                showActiveModal: '',
                modalName: '',
                mural: [],
                notificationsMural: [],
                pathName: window.location.pathname
            }
        },
        methods: {
            expand(data) 
            {
                this.$set(this.item[0]['menu'][data],'status_collapse', this.item[0]['menu'][data]['status_collapse'] == undefined ? true : !this.item[0]['menu'][data]['status_collapse']);
                this.$set(this.item[0]['menu'][data],'class', this.item[0]['menu'][data]['status_collapse']);
            },
            expandResponsive()
            {
                this.openAll = !this.openAll;
            },
            openModal(data, value)
            {
                this.showActiveModal = value;
                this.modalName = data;
                $(data).modal('show');
            },
            submenuIsActive(menu, value)
            {
                let vm = this;
                if(Object.keys(menu).length > 0)
                {
                    menu = Object.values(menu);
                    let collapse = menu.find(function(element) 
                    {
                        return element.route.name == vm.pathName
                    });
                    if(collapse != undefined)
                    {
                        return true;
                    }
                }
                return false
            },
            activeMenu()
            {
                for(let key in this.item[0]['menu'])
                {
                    if(this.item[0]['menu'][key]['is_submenu'])
                    {
                        let submenuResonse = this.submenuIsActive(this.item[0]['menu'][key]['menu'], key);
                        if(submenuResonse)
                        {
                            let expandResponse = this.expand(key);
                            return;
                        }
                    }
                }
            },
            resizeWindow()
            {
                if($(window).width() > 768)
                {
                    this.openAll = true;
                }
            },
            timeNotifications()
            {
                setInterval(this.requestNotifications(),300000);
            },
            requestNotifications()
            {
                axios
                .get(this.view[1])
                .then((response) => {
                    if(response.status == 200)
                    {
                        this.mural = response.data.data.read_status;
                        this.setNotificationMural();
                    }
                })
                .catch(e => {});
            },
            setNotificationMural()
            {
                if(!this.item[0]['menu']['mural']['menu'] == false)
                {
                    for(var i = 0; i < Object.keys(this.mural).length; i++)
                    {
                        for(let key in this.item[0]['menu']['mural']['menu'])
                        {
                            if(key == this.mural[i]['mural_name'] && this.mural[i]['all_read'] == "0")
                            {
                                this.$set(this.item[0]['menu']['mural']['menu'][key],'notification', this.mural[i]['count']);
                                this.$set(this.item[0]['menu']['mural'],'status_collapse', true);
                            }
                        }
                    }
                }   
            }
        },
        watch: {
            view(newValue,oldValue)
            {
                this.$set(this.$data,'item',JSON.parse(JSON.stringify(newValue)));
            }
        },
        created() {
            this.$set(this.$data,'item',JSON.parse(JSON.stringify(this.view)));
            this.activeMenu();
        },
        mounted() {
            let vm = this;
            $(window).resize(function(){
                vm.resizeWindow();
            });
            this.resizeWindow();
            this.requestNotifications(); 
            this.timeNotifications(); 
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/extras/_variables';
    .sidebar-responsive-content,
    .sidebar-submenu{
        display: flex;
        flex-direction: row;
    }
    .sidebar-all {
        background-color: $fs5-color2;
        padding-top: 1.8em;
        padding-bottom: 1.8em;
    }
    .sidebar-current{
        color: $fs5-color-26 !important;
    }
    .sidebar-justify {
        justify-content: space-between;
    }
    .sidebar-box-title {
        text-align: left;
    }
    .sidebar-btn-expand {
        text-align: right;
    }
    .sidebar-badge,
    .sidebar-notification,
    .sidebar-badge-notification {
        background-color: $fs5-color-26;
        border-radius: 2px;
        text-align: center;
        font-size: 0.65em;
        font-weight: 900;
        color: $fs5-color2;
        padding: 0.35em;
        font-family: Lato;
    }  
    .sidebar-badge-notification{
        opacity: 1;
        animation: blinker 4s linear infinite;
    } 
    .sidebar-badge-notification,
    .sidebar-notification {
        background-color: $fs5-color28 !important;
    }
    .sidebar-notification {
        box-shadow: 0 0 0.5em $fs5-color28;
        position: relative;
        border-radius: 50% !important;
        padding: 0.2em !important;
        width: 1.35em;
        height: 1.35em;
        margin-top: -2.3em;
        margin-left: 80%;
    }
    @keyframes blinker {
        50% {
            opacity: 0.1;
        }
    }
    .sidebar-icon-text {
        display: grid;
        grid-template-columns: auto 1fr auto auto;
        column-gap: 3.5%;
        align-items: center;
        padding: 0.45em;
        transition: .3s;
        padding-top: 0.85em;
        padding-bottom: 0.85em;
    }
    .sidebar-expand {
        background: transparent;
        border: none;
        outline: none;
    }
    .sidebar-li-second {
        margin: 0.7em;
    }
    .sidebar-a-first,
    .sidebar-label-first {
        color: $fs5-color-24;
        font-weight: 800;
        font-size: 0.82em;
    }
    .sidebar-label-first{
        margin-top: 0.3em;
        cursor: pointer;
    }
    .sidebar-ul-second {
        margin-left: 1.5em;
    }
    .sidebar-rotate180 {
        transform: rotate(180deg);
    }
    .active-menu {
        background-color: $fs5-color-25;
        border-left: 5px solid $fs5-color-26;
    }
    .sidebar-vector {
        transition: 1s;
        padding: 0.5em;
    }
    .sidebar-a-second {
        font-weight: 600;
        font-size: 0.85em;
        color: $fs5-color-24;
    }
    .sidebar-a-second:hover {
        color: $fs5-color-26;
    }
    .sidebar-icon {
        width: 1.55em;
        height: 1.55em;
    }
    .sidebar-responsive-content {
        justify-content: center;
        padding: 1em;
    }
    .sidebar-responsive-p {
        font-size: 1.5em;
    }
    .sidebar-responsive {
        display: none;
    }
    @media only screen and (max-width: 768px) {
        .sidebar-responsive {
            display: block;
        }
        .sidebar-icon-text {
            display: flex;
            flex-direction: row;
            justify-content: start;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/sidebar/index.vue